module.exports = __webpack_public_path__ + "static/media/_AttachFiles.f6db0246.scss";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/AttachFiles/_AttachFiles.scss
// module id = 446
// module chunks = 0